module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-single-row"
  }, [_c('div', {
    staticClass: "lightest larger bold d-flex p-2 pointer",
    class: _vm.paymentColor(_vm.payment),
    on: {
      "click": function($event) {
        return _vm.expandPaymentClick()
      }
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("\n                " + _vm._s(_vm.paymentTitle(_vm.payment)) + "\n                "), (_vm.isRefundProcessed) ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("(Refunded)")]) : _vm._e(), _vm._v(" "), (_vm.isRefundCanceled) ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("(Canceled)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "payment-amount"
  }, [_vm._v("\n                " + _vm._s(_vm.paymentValue(_vm.payment)) + "\n            ")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.payment.code))]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [(_vm.isExpanded) ? _c('i', {
    staticClass: "fas fa-chevron-up"
  }) : _c('i', {
    staticClass: "fas fa-chevron-down"
  })])])]), _vm._v(" "), (_vm.isExpanded) ? _c('div', {
    staticClass: "bg-faded border-light p-2"
  }, [(_vm.thisPaymentRefund) ? _c('refund-area', {
    attrs: {
      "refund": _vm.thisPaymentRefund,
      "payment": _vm.payment,
      "reservation": _vm.reservation,
      "isLegacyRefund": true
    }
  }) : _c('pay-in-area', {
    attrs: {
      "payment": _vm.mergedPayment,
      "reservation": _vm.reservation,
      "isFullyRefunded": _vm.isFullyRefunded
    },
    on: {
      "change": function($event) {
        return _vm.changed()
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0fe8a5df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe8a5df"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabPayments/paymentSingleRow.vue
// module id = 2028
// module chunks = 0